const allowedPaths = [
  '/guitar/',
  '/bass/',
  '/ukulele/',
  '/courses/',
  '/lessons/',
  '/songs',
  '/articles',
  '/search',
];

export function getTextContainerClassName(isFixedMatches) {
  const textContainerClassName =
    'center w-100-ns w-80 flex flex-row-ns flex-column flex-wrap-m items-center justify-center tl-l tc f3-l lh-solid white futura-heavy';
  const whenIdFixed = isFixedMatches ? 'f8' : 'pv3 f6';

  return `${textContainerClassName} ${whenIdFixed}`;
}

export function getWrapperClassName(matches, isFixed) {
  const baseClassName = matches ? 'bg-black w-100 pv2' : 'bg-black w-100 pv2-l';
  const wrapperClassName = isFixed ? `fixed z-4 ${baseClassName}` : baseClassName;

  return wrapperClassName;
}

export function getHeight(isFixed, matches) {
  if (!isFixed) {
    return 'auto';
  }

  if (isFixed && matches) {
    return 44;
  }

  return 96;
}

export function getTopPosition(isAuthFixed, location) {
  const { pathname } = location || {};
  const isHome = pathname === '/';
  if (isAuthFixed) {
    return 60;
  } else if (!isAuthFixed && isHome) {
    return 0;
  }
  return 64;
}

export function routeMatch(pathname) {
  let flag = false;
  try {
    if (pathname) {
      allowedPaths.forEach(path => {
        if (pathname?.indexOf(path) === 0) {
          flag = true;
        }
      });
    }
  } catch (err) {
    return flag;
  }
  return flag;
}

export function routePagesMatch(pathname) {
  return (pathname && pathname?.indexOf('/pages') === 0) || pathname === '/';
}

export function goToSignUp() {
  window.location = `${process.env.REACT_APP_CLIENT_SSO_URL}/sign-up?ref=${process.env.REACT_APP_CLIENT_FENDER_COM}/play/plans?session-started=true`;
}

export function goToPlans() {
  window.location = `${process.env.REACT_APP_CLIENT_SSO_URL}/sign-in?ref=${process.env.REACT_APP_CLIENT_FENDER_COM}/play/plans?session-started=true`;
}

export function getTopOffset(pathname, isAuthenticated, subscription) {
  const routeMatched = routeMatch(pathname);
  const isPages = routePagesMatch(pathname);
  const ctaPoint =
    document.getElementById('hero-block_cta_point') ||
    document.querySelector('.absolute.top-0.left-0.z-0.w-100.h-100.bg-top.bg-center');
  const aboveHeader = document.getElementById('above-header');
  if (!isPages && routeMatched && !isAuthenticated && aboveHeader) {
    return aboveHeader.clientHeight;
  }
  if (isPages && !routeMatched && !isAuthenticated && subscription !== 'active' && ctaPoint) {
    const heroHeight = ctaPoint.clientHeight;

    return heroHeight;
  }

  return 0;
}

export function shouldHidePagesBanner(conditions) {
  const { subscription, isAuthenticated, pathname, isFixed, isLarge } = conditions;
  const notValidsubscription = subscription !== 'pending' && subscription !== 'cancelled';
  const noAuthNoPagesMatch = !isAuthenticated && !routePagesMatch(pathname);
  const isAuthNotSubscription = isAuthenticated && notValidsubscription;

  return isLarge || !isFixed || noAuthNoPagesMatch || isAuthNotSubscription;
}

export function shouldBindEvent(pathname, subscription, isAuthenticated) {
  const routeMatched = routeMatch(pathname);
  const pagesMatched = routePagesMatch(pathname);
  const onSubscription =
    (subscription === 'pending' || subscription === 'cancelled') && isAuthenticated;

  return routeMatched || pagesMatched || onSubscription;
}
